import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CivilService {
  private apiUrl =  `${environment.apiUrl}/api/civil`; 
  

  constructor(private http: HttpClient) { }

  getCiviles(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener registros civiles:', error);
        return throwError(() => error);
      })
    );
  }
}
